"use client"

import { Button } from "@/components/ui/button"
import { LogOut, Globe } from "lucide-react"
import { useAuth } from "@/hooks/useAuth";
import { useRouter } from "next/navigation";

export function Navbar() {
  const router = useRouter();
  const {logout} = useAuth()

  const handleLogout = () => {
    logout();
    router.push("/login");
  };

  return (
    <nav className="bg-white border-b px-4 py-2 flex items-center justify-between">
      <div className="flex items-center">
        <h1 className="text-xl font-semibold mr-4">SupportPilot AI</h1>
        <div className="hidden md:flex items-center">
          <Button variant="ghost">Chat Assist</Button>
        </div>
      </div>
      <div className="flex items-center space-x-4">
        {/* <Button variant="ghost" size="icon">
          <Globe size={20} />
        </Button> */}
        <Button variant="ghost" size="icon" onClick={handleLogout}>
          <LogOut size={20} />
        </Button>
      </div>
    </nav>
  )
}